import React, { useRef, useState } from "react";
//#region types
import { TranslationKeys } from "translations";
import { FormHandles } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import {
  FormValidity,
  PageLayouts,
  RouteBreadCrumb,
  SimpleEntityTitle,
  useNavigationHistory,
  ViewPanel,
  WizardContextProvider,
} from "components/common";
import BusinessUnitCreateFooter from "./footer";
import BusinessUnitFormContainer from "./forms/businessUnitFormContainer";
import { useBusinessUnitService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";
import { NavMenuItem } from "models/propTypes/pageLayoutPropTypes";

const CreateBusinessUnit: React.FC = (props) => {
  const businessUnitService = useBusinessUnitService();
  const [selectedBusinessUnitName, setSelectedBusinessUnitName] = useState<string>();

  const formRef = useRef<FormHandles>(null);
  const { navigateToPreviousLocation } = useNavigationHistory();

  const currentBusinessUnitName = () => {
    return (
      selectedBusinessUnitName ??
      LocalizationHelperInstance.getFormattedMessage(TranslationKeys.BusinessUnit.NewBusinessUnit)
    );
  };

  const onSubmit = () => {
    return (formRef.current && formRef.current.submit()) || new Promise<void>((resolve) => resolve());
  };

  const onSubmitSuccess = (businessUnitId?: number) => {
    navigateToPreviousLocation({
      businessUnitId: businessUnitId,
      businessUnitName: formRef.current?.getValues && formRef.current.getValues().name,
    });
  };

  return (
    <PageLayouts.EntityFullScreen
      id={0}
      entityKey={`businessUnit`}
      navigation={<RouteBreadCrumb current={currentBusinessUnitName()} />}
      hasPermissions={businessUnitService.hasEditPermissions()}
      hideSpeedDial
    >
      <>
        <WizardContextProvider>
          <FormValidity
            render={(isValid, onValidityChange) => (
              <PageLayouts.EntityCreationLayout
                className={"projectCreationWizard"}
                upperLeftComponent={<SimpleEntityTitle title={currentBusinessUnitName()} />}
                upperRightComponent={<></>}
                lowerLeftComponent={undefined}
                footer={
                  <BusinessUnitCreateFooter
                    submitForm={onSubmit}
                    onSubmitSuccess={onSubmitSuccess}
                    isFormValid={isValid}
                  />
                }
              >
                {(() => {
                  const BusinessUnitFormNavContent: React.FC<{ setNavLayoutSections?: any; title?: any }> = (p) => (
                    <ViewPanel className={cssExports.wizardOuter}>
                      <BusinessUnitFormContainer
                        ref={formRef}
                        {...p}
                        selectedBusinessUnitChangeHandler={setSelectedBusinessUnitName}
                        selectedBusinessUnitName={selectedBusinessUnitName ?? ""}
                        onFormValidationChange={onValidityChange}
                      />
                    </ViewPanel>
                  );

                  const navItems: NavMenuItem[] = [
                    {
                      navKey: "businessUnit",
                      content: <BusinessUnitFormNavContent />,
                    },
                  ];
                  return <PageLayouts.NavigationLayout navItems={navItems} enableDelayedScrollToTarget />;
                })()}
              </PageLayouts.EntityCreationLayout>
            )}
          />
        </WizardContextProvider>
      </>
    </PageLayouts.EntityFullScreen>
  );
};

export default CreateBusinessUnit;
